// extracted by mini-css-extract-plugin
export const badge = "badge-module--badge--2MYnu";
export const medium = "badge-module--medium--btPAi";
export const small = "badge-module--small--2c3lM";